
import React from 'react';
import md5 from 'md5';
import { gunzipSync, strToU8, strFromU8 } from 'fflate';
import MessageServices from './MessageServices';
import axios from 'axios';

const CryptoJS = require('crypto-js');

/*---Storage---*/
function setStorage(key,value) {
    const valueEncrypto = UtilServices.cryptografar(JSON.stringify(value)).Obj;
    return localStorage.setItem(key,valueEncrypto);
};
function getStorage(key) {
    let resp = [];

    try {
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        resp = JSON.parse(UtilServices.descriptografarAES(storedValue));
      }
      return resp;
      
    } catch (ex) {
      console.error(ex);
      return resp;
    }
};
function clearStorage() {
    localStorage.removeItem("tokenusuario");
    localStorage.removeItem("dadosusuario");
    localStorage.removeItem("permissoesusuario");
    localStorage.removeItem("perfilselecionado");
    localStorage.removeItem("notificacao");
};

/*---Validações usadas no Input---*/
//Validações
function validatePhone(phone) {
    if (!phone) return true; // Retorna true se for null, undefined ou vazio

    // Remove tudo que não é número
    phone =  phone.replace(/[^0-9]/g, '');
    
    if(validateBrasil(phone)){
        return true;
    }else if(validateEUA(phone)){
        return true;
    } else {
        return false //telefone inválido
    }

    function validateEUA(phone) {
      
        let validFirstNumberPhone = false;
        let phoneLength = phone.length;

        if (phoneLength === 11) {
            validFirstNumberPhone = phone[0] === '1';  // Número deve começar com 1
        } else if (phoneLength === 10) {
            validFirstNumberPhone = phone[0] !== '0';  // Não pode começar com 0
        }
  
        return validFirstNumberPhone && phoneLength >= 10 && phoneLength <= 11;
    }
    function validateBrasil(phone){

        var phoneLength = phone.length;
        var start = 2;
        var validFirstNumberPhone = false;
        
        if (phone.indexOf('(') == -1) {
            start = 2;
            if (phoneLength == 11) {
                validFirstNumberPhone = phone.substr(start, 1) == 9;
            } else {
                validFirstNumberPhone = phone.substr(start, 1) != 9;
            }
        } else {
            start = 5;
            if (phoneLength == 15) {
                validFirstNumberPhone = phone.substr(start, 1) == 9;
            } else {
                validFirstNumberPhone = phone.substr(start, 1) >= 7;
            }
        }
    
        return validFirstNumberPhone && phoneLength >= 10 && phoneLength <= 11;
    }
};
function validateEmail(email) {
    if (!email) return true; // Retorna true se for null, undefined ou vazio

    const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
function validateCNPJ(cnpj) {

    if (!cnpj) return true; // Retorna true se for null, undefined ou vazio

    cnpj = cnpj.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos

    if (cnpj.length !== 14) return false;

    // Verifica se todos os dígitos são iguais (ex.: 11111111111111)
    if (/^(\d)\1+$/.test(cnpj)) return false;

    // Cálculo do primeiro dígito verificador
    let soma = 0;
    let pesos = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    for (let i = 0; i < 12; i++) {
        soma += cnpj[i] * pesos[i];
    }
    let resto = soma % 11;
    let primeiroDV = resto < 2 ? 0 : 11 - resto;

    if (parseInt(cnpj[12]) !== primeiroDV) return false;

    // Cálculo do segundo dígito verificador
    soma = 0;
    pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    for (let i = 0; i < 13; i++) {
        soma += cnpj[i] * pesos[i];
    }
    resto = soma % 11;
    let segundoDV = resto < 2 ? 0 : 11 - resto;

    if (parseInt(cnpj[13]) !== segundoDV) return false;

    return true;
}
function validateCPF(cpf) {

    if (!cpf) return true; // Retorna true se for null, undefined ou vazio

    cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos

    if (cpf.length !== 11) return false;

    // Verifica se todos os dígitos são iguais (ex.: 111.111.111-11)
    if (/^(\d)\1+$/.test(cpf)) return false;

    // Função para calcular os dígitos verificadores
    const calcularDV = (cpf, pesoInicial) => {
        let soma = 0;
        for (let i = 0; i < pesoInicial - 1; i++) {
            soma += cpf[i] * (pesoInicial - i);
        }
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    // Calcula e verifica o primeiro dígito verificador
    const primeiroDV = calcularDV(cpf, 10);
    if (parseInt(cpf[9]) !== primeiroDV) return false;

    // Calcula e verifica o segundo dígito verificador
    const segundoDV = calcularDV(cpf, 11);
    if (parseInt(cpf[10]) !== segundoDV) return false;

    return true;
}
function validateDate(date) {

    if (!date) return true; // Retorna true se for null, undefined ou vazio

    // Verifica se o formato é DD/MM/YYYY
    const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = date.match(dateRegex);
  
    if (!match) {
      return false; // Formato inválido
    }
  
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);
  
    // Verifica limites do mês e do ano
    if (month < 1 || month > 12 || year < 1000 || year > 9999) {
      return false; // Mês ou ano inválido
    }
  
    // Dias máximos para cada mês
    const daysInMonth = [31, (isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  
    // Verifica se o dia é válido para o mês
    if (day < 1 || day > daysInMonth[month - 1]) {
      return false; // Dia inválido
    }
  
    return true; // Data válida
      
    // Função auxiliar para verificar se um ano é bissexto
    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

}
function validateCCM(ccm) {

    if (!ccm) return true; // Retorna true se for null, undefined ou vazio

    // Remove os separadores para validar apenas os números
    const cleanedCCM = ccm.replace(/\D/g, "");
  
    // Verifica se tem exatamente 11 dígitos
    if (cleanedCCM.length !== 11) {
        return false; // Formato inválido
    }
  
    // Verifica se todos os caracteres são numéricos
    if (!/^\d{11}$/.test(cleanedCCM)) {
        return false; // Formato inválido
    }
    
    return true

}
function validateCurrency(value, min = 0, max = Number.MAX_VALUE) {

    if (!value) return true; // Retorna true se for null, undefined ou vazio

    // Remove os espaços e verifica se o valor é vazio
    if (!value || typeof value !== "string") return false;
  
    // Remove o símbolo de moeda e formatação
    const numericValue = parseFloat(
      value.replace(/[^0-9,.-]+/g, "").replace(",", ".")
    );
  
    // Verifica se o valor é um número válido
    if (isNaN(numericValue)) return false;
  
    // Verifica se está dentro do intervalo permitido
    if (numericValue < min || numericValue > max) return false;
  
    return true;
}
function validateCNAE(cnae) {
    
    if (!cnae) return true; // Retorna true se for null, undefined ou vazio

    // Remove quaisquer espaços ou caracteres adicionais
    cnae = cnae.trim();
  
    // Expressão regular para validar o formato do CNAE
    const regex = /^\d{4}-\d\/\d{2}$/;
  
    if (!regex.test(cnae)) {
      return false;
    }
  
    // Validação adicional para números específicos do CNAE
    const [group, division, subclass] = cnae.split(/[-/]/); // Divide o CNAE em partes
  
    // Verifica se os valores numéricos estão no intervalo esperado
    if (parseInt(group, 10) < 1000 || parseInt(group, 10) > 9999) {
      return false;
    }
  
    if (parseInt(division, 10) < 0 || parseInt(division, 10) > 9) {
      return false;
    }
  
    if (parseInt(subclass, 10) < 0 || parseInt(subclass, 10) > 99) {
      return false;
    }
  
    return true;
}
function validateCEP(value) {
    
    if (!value) return true; // Retorna true se for null, undefined ou vazio

    // Remove espaços e caracteres não numéricos para garantir que a validação funcione
    value = value.trim();
  
    // Expressão regular para o formato de CEP
    const cepRegex = /^[0-9]{5}-?[0-9]{3}$/;
  
    // Verifica se o valor corresponde ao formato de CEP
    if (!cepRegex.test(value)) {
      return false; // Formato inválido
    }

    return true; // CEP válido
}
function validateMonthYear(date) {
    if (!date) return true; // Retorna true se for null, undefined ou vazio

    // Verifica se o formato é MM/YYYY
    const dateRegex = /^(\d{2})\/(\d{4})$/;
    const match = date.match(dateRegex);

    if (!match) {
        return false; // Formato inválido
    }

    const month = parseInt(match[1], 10);
    const year = parseInt(match[2], 10);

    // Verifica se o mês está entre 1 e 12 e se o ano está dentro de um intervalo aceitável
    if (month < 1 || month > 12 || year < 1000 || year > 9999) {
        return false; // Mês ou ano inválido
    }

    return true; // Data válida
}
 
  
//Mascaras
function maskPhone(input) {
    //Internacionais
    if (input.startsWith('+')) {
        //EUA 
        if (input.startsWith('+1')) {
            return maskInputEUA(input);
        }
        return input;
    //Brazil
    }else{
        return maskInputBrazil(input);
    }

    function maskInputBrazil(input)
    {
        if (input.length <= 16) {
            // Remove qualquer caracter não numérico
            const cleaned = input.replace(/[^0-9+]/g, '');
      
            // Aplica a máscara
            let formatted = '';
            for (let i = 0; i < cleaned.length; i++) {
                if (i === 0) {
                    formatted = `(${cleaned[i]}`;
                } else if (i === 2) {
                    formatted += `) ${cleaned[i]}`;
                } else if (i === 3) {
                    formatted += ` ${cleaned[i]}`;
                } else if (i === 7) {
                    formatted += `-${cleaned[i]}`;
                } else {
                    formatted += cleaned[i];
                }
            }
            return formatted;
        }
    }
    function maskInputEUA (input)
    {
        if (input.length <= 16) {
            // Remove qualquer caractere não numérico, mas permite o '+'
            const cleaned = input.replace(/[^0-9+]/g, '');
    
            // Aplica a máscara
            let formatted = '';
            for (let i = 0; i < cleaned.length; i++) {
                if (i === 0 && cleaned[i] === '+') {
                    formatted = cleaned[i]; // Mantém o símbolo '+'
                } else if (i === 2) {
                    formatted += ` (${cleaned[i]}`; // Código de área (abertura dos parênteses)
                } else if (i === 5) {
                    formatted += `) ${cleaned[i]}`; // Fecha parênteses e coloca espaço
                } else if (i === 8) {
                    formatted += `-${cleaned[i]}`; // Adiciona o hífen após os 3 primeiros números
                } else {
                    formatted += cleaned[i]; // Adiciona o restante dos números
                }
            }
            return formatted;
        }
    }
};
function maskCPF(input)
{
    if (/^\d+$/.test(input)) {
        input = input.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4",
        ); 
    }

    return input;
}
function maskCNPJ(value) {
    // Remove tudo que não for número
    value = value.replace(/\D/g, '');

    // Aplica a máscara progressivamente
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4");
    value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");

    return value;
}
function maskDate(input) {
    if (!input) return ""
    
    input = input.replace(/\D/g, ""); // Remove caracteres não numéricos
  
    if (input.length >= 1) {
      const day = parseInt(input.substring(0, 2), 10);
      if (day > 31) {
        input = "" // "31" + input.substring(2); // Limita o dia ao máximo de 31
      }
    }
  
    if (input.length >= 3) {
      const month = parseInt(input.substring(2, 4), 10);
      if (month > 12) {
        input = input.substring(0, 2);
      }
    }
  
    if (input.length > 2) {
      input = input.replace(/^(\d{2})(\d)/, "$1/$2"); // Adiciona a barra após o dia
    }
  
    if (input.length > 5) {
      input = input.replace(/^(\d{2}\/\d{2})(\d)/, "$1/$2"); // Adiciona a barra após o mês
    }
  
    return input.substring(0, 10); // Limita ao formato DD/MM/YYYY
}
function maskCCM(input) {
    input = input.replace(/\D/g, ""); // Remove caracteres não numéricos
  
    // Aplica a máscara no formato 000.000.000-00
    if (input.length > 3) {
      input = input.replace(/^(\d{3})(\d)/, "$1.$2"); // Adiciona o primeiro ponto
    }
    if (input.length > 6) {
      input = input.replace(/^(\d{3}\.\d{3})(\d)/, "$1.$2"); // Adiciona o segundo ponto
    }
    if (input.length > 9) {
      input = input.replace(/^(\d{3}\.\d{3}\.\d{3})(\d)/, "$1-$2"); // Adiciona o traço
    }
  
    return input.substring(0, 14); // Limita ao formato 000.000.000-00
}
function maskCurrency(value) {
    if (!value) return ""
    
    // Remove caracteres não numéricos, exceto vírgulas e pontos
    value = value.replace(/\D/g, "");
  
    // Formata para moeda brasileira (ou outro formato)
    const formattedValue = (Number(value) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  
    return formattedValue;
}
function maskCNAE(input) {
    // Remove todos os caracteres que não sejam dígitos
    input = input.replace(/\D/g, "");
  
    // Aplica a máscara no formato 9999-9/99
    if (input.length > 4) {
      input = input.replace(/^(\d{4})(\d)/, "$1-$2");
    }
    if (input.length > 6) {
      input = input.replace(/^(\d{4}-\d)(\d{2})/, "$1/$2");
    }
  
    // Limita o tamanho ao máximo permitido
    return input.substring(0, 9);
}
function maskCEP(value) {
    if(!value) return;
    // Remove caracteres não numéricos
    value = value.replace(/\D/g, "");
  
    // Adiciona o hífen entre o 5º e o 6º dígito
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");
  
    // Limita o valor a 9 caracteres no formato 12345-678
    return value.substring(0, 9);
}
function maskPercentage(input) {
    input = input.replace(/\D/g, ""); // Remove caracteres não numéricos
    
    if (input === "") return ""; // Permite deletar tudo
    
    let value = parseInt(input, 10);
    if (isNaN(value)) return ""; // Evita erro ao deletar tudo

    if (value > 100) {
        value = 100; // Limita o valor máximo a 100
    }

    return value + "%"; // Adiciona o símbolo de porcentagem
}
function maskMonthYear(input) {
    input = input.replace(/\D/g, ""); // Remove caracteres não numéricos

    if (input.length >= 1) {
        const month = parseInt(input.substring(0, 2), 10);
        if (month > 12) {
            input = "12"; // Limita o mês a 12
        }
    }

    if (input.length > 2) {
        input = input.replace(/^(\d{2})(\d)/, "$1/$2"); // Adiciona a barra após o mês
    }

    return input.substring(0, 7); // Limita ao formato MM/YYYY
}
function maskRG(input) {
    // Remove qualquer caractere não numérico
    const cleaned = input.replace(/\D/g, '');

    // Aplica a máscara dinamicamente para RGs de 7 a 9 dígitos
    let formatted = '';
    for (let i = 0; i < cleaned.length; i++) {
        if ((cleaned.length === 7 && (i === 1 || i === 4)) || 
            (cleaned.length === 8 && (i === 2 || i === 5)) || 
            (cleaned.length === 9 && (i === 2 || i === 5))) {
            formatted += `.${cleaned[i]}`; // Adiciona ponto nos locais corretos
        } else if ((cleaned.length === 7 && i === 6) ||
                   (cleaned.length === 8 && i === 7) ||
                   (cleaned.length === 9 && i === 8)) {
            formatted += `-${cleaned[i]}`; // Adiciona hífen antes do dígito verificador
        } else {
            formatted += cleaned[i];
        }
    }
    return formatted;
}

/*---Perfils---*/
function perfilFiltrar(permissoes, idPerfil) {
    let perfisFiltrado = [];

    // Utiliza o filter para encontrar todos os perfis que correspondem
    perfisFiltrado = Object.values(permissoes).filter((perfil) => {
        return perfil.idPerfil === idPerfil
    });

    return perfisFiltrado;
}

function perfilFiltrarMenor(permissoes) {
    let perfisFiltrado = [];
    // Encontrar o menor ID de perfil
    const menorIdPerfil = Math.min(...Object.values(permissoes).map(p => p.idPerfil));

    // Filtrar apenas os perfis que possuem o menor idPerfil
    perfisFiltrado = Object.values(permissoes).filter(p => p.idPerfil === menorIdPerfil);
    
    return perfisFiltrado;
};

  
/*---Outras Utilidades---*/
function cryptografar(element) {
    return {
        Hash: Md5(element),
        Obj: AES(element),
    };

  function Md5(obj) {
        let myJson = JSON.stringify(obj);
        return md5(myJson).toUpperCase();
  };
  function AES(conteudo) {
      var key = CryptoJS.enc.Utf8.parse('adde4cee8bdcce40');
      var iv = CryptoJS.enc.Utf8.parse('adde4cee8bdcce40');
      var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(conteudo)), key, {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
  };
};
function descriptografarAES(element) {
    const key = CryptoJS.enc.Utf8.parse('adde4cee8bdcce40');
    const iv = CryptoJS.enc.Utf8.parse('adde4cee8bdcce40');
    const decrypted = CryptoJS.AES.decrypt(element, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedStr = CryptoJS.enc.Utf8.stringify(decrypted);
    return JSON.parse(decryptedStr); // Retorna o objeto original
};
function decompressData(data) {
    const bytes = strToU8(atob(data), true);
    return JSON.parse(strFromU8(gunzipSync(bytes.subarray(4))));
};
function errorApi(err) {
    // Verifica se o erro é de autenticação ou autorização (401 ou 403)
    let messageInativacao = extractErrorMessage(err);
    if (err?.response?.status === 401 || err?.response?.status === 403 || messageInativacao.includes("A sessão que você estava utilizando foi inativada")) {
        // Limpa todos os dados armazenados localmente
        clearStorage();

        if(messageInativacao.includes("A sessão que você estava utilizando foi inativada"))
        {
            MessageServices.ShowError(messageInativacao);
        }

        // Exibe o alerta para o usuário
        MessageServices.ShowWarning('Sessão expirada. Você será redirecionado.');

        //Redireciona o usuário para a página principal após 2 segundos
        setTimeout(() => {
            window.location.href = '/';
        }, 2000);

    } else {
        
        // Caso o erro não seja de autenticação, trata os outros erros
        console.error('Erro:', err);
        // Exibe a mensagem de erro extraída
        MessageServices.ShowError(extractErrorMessage(err));
    }

    // Função auxiliar para extrair mensagens de erro
    function extractErrorMessage(error) {
        try {
            // Pega primeiro o erro que foi tratado pela API
            if (error?.response?.data?.message) {
                return error?.response?.data?.message;
            }

            // Tenta pegar a primeira linha do erro, caso seja outro tipo de erro que a API não pegou.
            if (error?.response?.data) {
                return error.response.data.split('\n')[0];
            }
        } catch (e) {
            console.error('Erro ao extrair a mensagem de erro:', e);
        }

        // Mensagem genérica de fallback
        return 'Erro ao realizar a consulta. Por favor, entre em contato com o suporte técnico.';
    }
};
function managerToken(token) {
    try {
        if(!token){
           throw 'Token inválido ou vazio';    
        }
        //seta token no localStorage
        setStorage(
            "tokenusuario",
            token,
        );
        //Atualiza o token no Authorization Axios.
        axios.defaults.headers.common['Authorization'] = `bearer ${token}`;

    } catch (ex) {
        let error = `Erro no Token: ${ex.message}`;
        MessageServices.ShowError(error);
        clearStorage(); //Caso o erro limpa o token
        throw ex;
    }
};
function verificarToken() {
    try {

        let token = getStorage("tokenusuario");
        
        if(token.length === 0){
           return false;
        }
        // Configura os cabeçalhos globais do Axios
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        return true;

    } catch (ex) {
        return false;
    }
};
function convertDataHora(data) {
    if(!data){
       return 'sem data do ultimo acesso'
    }

    const dt = new Date(data);

    // Extrair componentes da data e hora
    const dia = String(dt.getDate()).padStart(2, '0'); // Garantir que o dia tenha 2 dígitos
    const mes = String(dt.getMonth() + 1).padStart(2, '0'); // Mês começa de 0, por isso somamos 1
    const ano = dt.getFullYear();
    
    const horas = String(dt.getHours()).padStart(2, '0');
    const minutos = String(dt.getMinutes()).padStart(2, '0');
    const segundos = String(dt.getSeconds()).padStart(2, '0');
  
    // Formatar no formato dd/mm/yyyy hh:mm:ss
    return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
  
};
function stringToJsx(stringHtml) {
    return React.createElement('div', { dangerouslySetInnerHTML: { __html: stringHtml } });
};
function primeiraLetraMaiuscula(text) {
    if (!text) return ''; // Verifica se o texto é vazio ou nulo
    return text
        .split(' ') // Divide o texto em palavras
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitaliza cada palavra
        .join(' '); // Junta as palavras de volta em uma string
};
function searchLst(e, lst) {
    // Converte o termo de pesquisa para minúsculas
    const searchTerm = e.toLowerCase();
    // Filtra os itens da lista com base na pesquisa
    return lst.filter((item) => {
      // Percorre todas as propriedades do item
      return Object.values(item).some((value) => {
        // Se o valor for uma lista (Telefone ou Email)
        if (Array.isArray(value)) {
          // Percorre cada item da lista e verifica se algum campo contém o termo de pesquisa
          return value.some((subItem) => {
            return Object.values(subItem).some((subValue) => {
              return subValue?.toString().toLowerCase().includes(searchTerm);
            });
          });
        }
        // Se o valor não for uma lista, apenas verifica se contém o termo de pesquisa
        return value?.toString().toLowerCase().includes(searchTerm);
      });
    });
};
function colorizeJson(jsonObj) {
    // Converte o objeto JSON para uma string formatada com identação
    const jsonString = JSON.stringify(jsonObj, null, 2);
    
    // Aplica a colorização nas chaves e valores do JSON
    return jsonString
      .replace(/"(.*?)":/g, '<span class="json-key">"$1":</span>')  // Coloriza as chaves
      .replace(/: "(.*?)"/g, ': <span class="json-value">"$1"</span>') // Coloriza os valores string
      .replace(/: (\d+)/g, ': <span class="json-number">$1</span>'); // Coloriza números
};  
function generateUUID () {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    } else {
      // Fallback UUID v4
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
};
function base64inPDF(base64) {
  const byteCharacters = atob(base64);
  const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  const agora = new Date();
  const pad = n => String(n).padStart(2, '0');
  const timestamp = `${agora.getFullYear()}-${pad(agora.getMonth() + 1)}-${pad(agora.getDate())}_${pad(agora.getHours())}-${pad(agora.getMinutes())}-${pad(agora.getSeconds())}`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `arquivo-${timestamp}.pdf`;
  link.click();
  URL.revokeObjectURL(url);
}
  

const UtilServices = {
    /*---Storage---*/
    setStorage(key,value){
        return setStorage(key,value)
    },
    getStorage(key){
        return getStorage(key)
    },
    clearStorage(key){
        return clearStorage(key)
    },

    /*---Validações usadas no Input---*/
    //Validações
    validatePhone(phone){
        return validatePhone(phone)
    },
    validateEmail(email){
        return validateEmail(email);
    },
    validateCNPJ(cnpj){
        return validateCNPJ(cnpj);
    },
    validateCPF(cpf){
        return validateCPF(cpf);
    },
    validateDate(date){
        return validateDate(date);
    },
    validateCCM(ccm){
        return validateCCM(ccm);
    },
    validateCurrency(value){
        return validateCurrency(value);
    },
    validateCNAE(cnae){
        return validateCNAE(cnae);
    },
    validateCEP(cep){
        return validateCEP(cep);
    },
    validateMonthYear(date){
        return validateMonthYear(date);
    },

    
    //Mascaras
    maskPhone(input){
        return maskPhone(input);
    },
    maskCNPJ(input){
        return maskCNPJ(input);
    },
    maskCPF(input){
        return maskCPF(input);
    },
    maskDate(input){
        return maskDate(input);
    },
    maskCCM(input){
        return maskCCM(input);
    },
    maskCurrency(input){
        return maskCurrency(input);
    },
    maskCNAE(input){
        return maskCNAE(input);
    },
    maskCEP(input){
        return maskCEP(input);
    },
    maskPercentage(input){
        return maskPercentage(input);
    },
    maskMonthYear(input){
        return maskMonthYear(input);
    },
    maskRG(input){
        return maskRG(input);
    },
    /*---Perfils---*/
    perfilFiltrar(lst,idPerfil,app){
        return perfilFiltrar(lst,idPerfil,app)
    },
    perfilFiltrarMenor(lst,nomeApp){
        return perfilFiltrarMenor(lst,nomeApp)
    },

    /*---Outras Utilidades---*/
    cryptografar(element){
        return cryptografar(element);
    },
    descriptografarAES(element){
        return descriptografarAES(element);
    },
    decompressData(data){
        return decompressData(data);
    },
    errorApi(err){
        return errorApi(err);
    },
    managerToken(token){
        return managerToken(token);
    },
    stringToJsx(stringHtml) {
        return stringToJsx(stringHtml);
    },
    verificarToken(){
        return verificarToken()
    },
    convertDataHora(data){
        return convertDataHora(data)
    },
    primeiraLetraMaiuscula(string){
        return primeiraLetraMaiuscula(string)
    },
    searchLst(e,lst){
        return searchLst(e,lst)
    },
    colorizeJson(json){
        return colorizeJson(json)
    },
    generateUUID(){
        return generateUUID()
    },
    base64inPDF(base64){
        return base64inPDF(base64);
    }
};

export default UtilServices;
